import { ProductGroupsApiType } from '@/components/OrderWizard/Contexts/OrderContainersContext/ProductGroups/useProductGroups'
import { DestinationProductCombination, SupplyOwnerDefinition } from './types'

export function getOptions(metadata: MetadataResponse | undefined, key: keyof MetadataResponse) {
  if (!metadata?.[key]) return []
  const data = metadata[key]
  const items = Array.isArray(data) ? data : Object.values(data).flat()
  return items.map((m) => ({
    label: typeof m === 'object' ? (m.label ?? m.name) : m,
    value: typeof m === 'object' ? (m.label ?? m.id) : m,
  }))
}

export function getDefaultSupplyOwners(
  orderDestinations,
  destinationProductCombos: DestinationProductCombination[]
): SupplyOwnerDefinition[] {
  return destinationProductCombos.map((combo) => {
    const destination = orderDestinations.find((d) => d.store_number === combo.locationName)
    return { location_name: combo.locationName, supply_owner_id: destination?.supply_owner_id, product: combo.product }
  })
}

export function getDestinationProductsFromCompartments(
  compartments,
  productGroups: ProductGroupsApiType['productGroups'],
  isByProduct: boolean
): DestinationProductCombination[] {
  const comps = isByProduct ? Object.values(productGroups).flat() : compartments

  const destinationProductCombos = new Array<DestinationProductCombination>()
  comps.reduce((acc, compartment) => {
    compartment.targets?.forEach((t) => {
      const combo = acc.find((c) => c.locationName === t.location_name && c.product === compartment.product_name)
      if (combo) {
        combo.tankIds.push(compartment.compartment_index)
      } else {
        acc.push({
          locationName: t.location_name,
          product: compartment.product_name,
          tankIds: [compartment.compartment_index],
        })
      }
    })
    return acc
  }, destinationProductCombos)
  return destinationProductCombos
}
